import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {getAutoAddress} from '../../../action/autoAddress/getAutoAddress';
import {getFindAddress,getFindAddressSecondCall} from '../../../action/autoAddress/getFindAddress'
import { analyticsClickEvent } from '../../../action/firebaseAnalytics/firebaseAnalytics';
import { GTMFieldInteraction, GTMFieldValidChange } from '../../../utils/GtmDatalayer';
import { PropTypes } from 'prop-types';
import Cookies from 'universal-cookie';
import { frontEndLogs } from '../../../action/logs/frontEndLogs';
import { removeSpecialCharacterInAddressFields } from '../../../utils/helpers/addressFieldValidation';

export class AutoAddress extends React.Component {
 constructor(props) {
   super(props);
   this.state = {
     suggestions: [],
     text:'',
     fields:{},
     error:{},
     changeText:false,
     showValidation:this.props.showAppValidations,
     addressTextare:false,
     editvalue:false,
     removepopulateValue:false,
     showFieldOptions: false,
     currentAddressFieldNames :[
      "Current_Flat_No__c",
      "Current_House_Name__c",
      "HouseNumber__c",
      "Address_Line1__c",
      "Address_Line2__c",
      "Town__c",
      "Postal_Code__c",
    ],
    previousAddressFieldNames :[
      "Previous_Flat_No__c",
      "Previous_House_Name__c",
      "Previous_HouseNumber__c",
      "Previous_Address_Line1__c",
      "Previous_Address_Line2__c",
      "Previous_Town__c",
      "Previous_Postal_Code__c",
     ],
     fieldValidation: false,
     editManuallyButton: false,
     isChangeClicked: false
   }

   this.hasAnotherCall =this.hasAnotherCall.bind(this);
 }

  isCurrentAddress=()=>this.props.field_api_name === 'Current_Address_Country__c';
  isPreviousAddress=()=> this.props.field_api_name === 'Previous_Address__C';

 componentDidMount(){
  this.handlingValidation(this.state.text);
  this.addressPrePopulatedInPurchaseflow();
 }

componentDidUpdate(prevProps) {
  if (prevProps.saveApplicationData === this.props.saveApplicationData) {
    return;
  }

  if(prevProps.clearPurchaseFlowPopulateAddress !== this.props.clearPurchaseFlowPopulateAddress){
      this.setState({text:'',addressTextare:false,editvalue:null,showFieldOptions:false})
  }
}


 purchaseFlowAddressTextArea=()=>{
  const cookie = new Cookies();
  let addressParts=[];
  if(cookie.get('flatAbode')) addressParts.push(cookie.get('flatAbode'));
  if(cookie.get('houseandBuildingName')) addressParts.push(cookie.get('houseandBuildingName'));
  if(cookie.get('houseandBuildingNumber')) addressParts.push(cookie.get('houseandBuildingNumber'));
  if(cookie.get('numberAndStreet')) addressParts.push(cookie.get('numberAndStreet'));
  if(cookie.get('addressLine2')) addressParts.push(cookie.get('addressLine2'));
  if(cookie.get('townOrCity')) addressParts.push(cookie.get('townOrCity'));
  if(cookie.get('postcode')) addressParts.push(cookie.get('postcode'));
  const formattedPurchaseFlowAddress=addressParts.filter(Boolean).join(', ');
  return formattedPurchaseFlowAddress || null;
 }

  addressPrePopulatedInPurchaseflow = async () => {
    const cookie = new Cookies();
    let prePopulatePurchaseAddressfieldValues = {};
    let saveInputApplicationData = {};

    if (this.props.field_api_name === 'Current_Address_Country__c') {
    let purchaseRedirectToken = window.location.search.includes('redirectToken');
      if (cookie.get('sourceURL') && purchaseRedirectToken) {
        let fieldValues = {};
        let stageValues = {};
        let cookiesValues = { DOB: cookie.get('Dob'), flatAbode: cookie.get('flatAbode'), houseandBuildingName: cookie.get('houseandBuildingName'), houseandBuildingNumber: cookie.get('houseandBuildingNumber'), street: cookie.get('numberAndStreet'), postcode: cookie.get('postcode'), townOrCity: cookie.get('townOrCity'), addressLine2: cookie.get('addressLine2') }
        frontEndLogs('Purchase link cookie address params ', false, 200, 'addressPrePopulatedInPurchaseflow', cookiesValues);
        analyticsClickEvent('purchase_link_cookie_address_params', cookiesValues);
        prePopulatePurchaseAddressfieldValues = await this.vanityAddressPrePopulate(prePopulatePurchaseAddressfieldValues);
        saveInputApplicationData = Object.assign({}, ...this.props.saveApplicationData);
        saveInputApplicationData = await this.handleValidationAddressAndTown(saveInputApplicationData,prePopulatePurchaseAddressfieldValues);

        if (cookie.get('postcode') && cookie.get('postcode').trim() !== '' && cookie.get('postcode').length < 9 && /^[a-zA-Z0-9\s]*$/.test(cookie.get('postcode'))) {
          saveInputApplicationData['Postal_Code__c'] = cookie.get('postcode').trim();
          prePopulatePurchaseAddressfieldValues['Postal_Code__c'] = '';
          this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
        } else {
          fieldValues['Postal_Code__c'] = 'This is Required';
          stageValues['Postal_Code__c'] = false;
          this.props.appvalidations(fieldValues);
          this.props.thirdSectionValidationUpdate(stageValues);
        }
        this.props.saveApplicationDatas(saveInputApplicationData);

        await this.sendAddressChangepropsInPurchaseFlow();

        const formattedPurchaseFlowAddress=this.purchaseFlowAddressTextArea();
        const hasAddress = Boolean(formattedPurchaseFlowAddress);
        this.setState({
          text:formattedPurchaseFlowAddress || '',
          addressTextare:hasAddress,
          editManuallyButton:hasAddress,
          showFieldOptions:hasAddress,
        },()=>{
          this.displayAddressFields('autoUpdate');
        })
      }
    }
  }

  handleValidationAddressAndTown = (saveInputApplicationData,prePopulatePurchaseAddressfieldValues)=>{
    const cookie = new Cookies();
    let fieldValues = {}, stageValues = {};
    let purchaseRedirectToken = window.location.search.includes('redirectToken');
    if(cookie.get('sourceURL') && purchaseRedirectToken) {
      if(cookie.get('townOrCity') == null || cookie.get('townOrCity') == '' || cookie.get('townOrCity') == undefined) {           
      fieldValues['Town__c'] = 'This is Required';
      stageValues['Town__c'] = false;

      this.props.appvalidations(fieldValues); this.props.thirdSectionValidationUpdate(stageValues);
      }
    }
    if (cookie.get('townOrCity')) {
      let townInfo = {}
      let townValidation = removeSpecialCharacterInAddressFields(townInfo,'townInfo',cookie.get('townOrCity'),'autoAddressPrePopulate');
      if (townValidation) {
        saveInputApplicationData['Town__c'] = townValidation['townInfo'];

        prePopulatePurchaseAddressfieldValues['Town__c'] = '';
        this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
    }

    if (cookie.get('addressLine2')) {
      let addressLineTwoInfo = {}
      let addressLineTwo = removeSpecialCharacterInAddressFields(addressLineTwoInfo,'addressLineTwoInfo',cookie.get('addressLine2'),'autoAddressPrePopulate');
      if (addressLineTwo) {
        saveInputApplicationData['Address_Line2__c'] = addressLineTwo['addressLineTwoInfo'];

        prePopulatePurchaseAddressfieldValues['Address_Line2__c'] = '';
        this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
      
    }
    return saveInputApplicationData;
  }

  vanityAddressPrePopulate = async (prePopulatePurchaseAddressfieldValues) =>{
    const cookie = new Cookies();
    if (cookie.get('flatAbode')) {
      let flatAbode = {}
      const flatAbodeApplicationDetails = Object.assign({}, ...this.props.saveApplicationData);
      let cookiesFlatNumber = removeSpecialCharacterInAddressFields(flatAbode, 'flatNumberInfo', cookie.get('flatAbode'), 'autoAddressPrePopulate');
      if (cookiesFlatNumber) {
        flatAbodeApplicationDetails['Current_Flat_No__c'] = cookiesFlatNumber['flatNumberInfo'];
        this.props.saveApplicationDatas(flatAbodeApplicationDetails);
        prePopulatePurchaseAddressfieldValues['Current_Flat_No__c'] = '';
        this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
      
    }

    if (cookie.get('houseandBuildingName')) {
      let houseName = {}
      const houseandBuildingNameApplicationDetails = Object.assign({}, ...this.props.saveApplicationData);
      let cookiesHouseName = removeSpecialCharacterInAddressFields(houseName, 'buildingNameInfo', cookie.get('houseandBuildingName'), 'autoAddressPrePopulate');
      if (cookiesHouseName) {
        houseandBuildingNameApplicationDetails['Current_House_Name__c'] = cookiesHouseName['buildingNameInfo'];
        this.props.saveApplicationDatas(houseandBuildingNameApplicationDetails);
        prePopulatePurchaseAddressfieldValues['Current_House_Name__c'] = '';
        this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
    }

    if (cookie.get('houseandBuildingNumber')) {
      let buildingNumber = {}
      const houseandBuildingNumberApplicationDetails = Object.assign({}, ...this.props.saveApplicationData);
      let cookiesBuildingNumber = removeSpecialCharacterInAddressFields(buildingNumber, 'buildingNumberInfo', cookie.get('houseandBuildingNumber'), 'autoAddressPrePopulate');
      if (cookiesBuildingNumber) {
        houseandBuildingNumberApplicationDetails['HouseNumber__c'] = cookiesBuildingNumber['buildingNumberInfo'];
        this.props.saveApplicationDatas(houseandBuildingNumberApplicationDetails);
        prePopulatePurchaseAddressfieldValues['HouseNumber__c'] = '';
        this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
    }

    prePopulatePurchaseAddressfieldValues = this.handleToSetExistingAddressFields(prePopulatePurchaseAddressfieldValues)
    return prePopulatePurchaseAddressfieldValues;
  }

  handleToSetExistingAddressFields = async(prePopulatePurchaseAddressfieldValues)=>{
    const cookie = new Cookies();
    let fieldValues = {}, 
    stageValues = {};
    let purchaseRedirectToken = window.location.search.includes('redirectToken');
    if(cookie.get('sourceURL') && purchaseRedirectToken) {
      if(cookie.get('numberAndStreet') == null || cookie.get('numberAndStreet') == '' || cookie.get('numberAndStreet') == undefined) {           
      fieldValues['Address_Line1__c'] = 'This is Required';
      stageValues['Address_Line1__c'] = false;

      this.props.appvalidations(fieldValues);
      this.props.thirdSectionValidationUpdate(stageValues);
      }
    }
    if (cookie.get('numberAndStreet')) {
      let numberAndStreet = {}
      const numberAndStreetApplicationDetails = Object.assign({}, ...this.props.saveApplicationData);
      let cookiesNumberAndStreet = removeSpecialCharacterInAddressFields(numberAndStreet, 'addressLineOneInfo', cookie.get('numberAndStreet'), 'autoAddressPrePopulate');
      if (cookiesNumberAndStreet) {
        numberAndStreetApplicationDetails['Address_Line1__c'] = cookiesNumberAndStreet['addressLineOneInfo'] ;
        this.props.saveApplicationDatas(numberAndStreetApplicationDetails);
        prePopulatePurchaseAddressfieldValues['Address_Line1__c'] = '';
        this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
    }

    if (cookie.get('addressLine2')) {
      let addressLineTwoInfo = {}
      const addressLineTwoApplicationDetails = Object.assign({}, ...this.props.saveApplicationData);
      let updatedAddressLineTwoValue = removeSpecialCharacterInAddressFields(addressLineTwoInfo, 'addressLineTwoInfo',  cookie.get('addressLine2'), 'autoAddressPrePopulate');
      if (updatedAddressLineTwoValue) {
        addressLineTwoApplicationDetails['Address_Line2__c'] = updatedAddressLineTwoValue['addressLineTwoInfo'];
        this.props.saveApplicationDatas(addressLineTwoApplicationDetails);
        prePopulatePurchaseAddressfieldValues['Address_Line2__c'] = '';
        this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
    }

    if (cookie.get('townOrCity')) {
      let townInfo = {}
      const townApplicationInputDetailsData = Object.assign({}, ...this.props.saveApplicationData);
      let updatedTownValue = removeSpecialCharacterInAddressFields(townInfo,'townInfo',cookie.get('townOrCity'),'autoAddressPrePopulate');
      if(updatedTownValue){
        townApplicationInputDetailsData['Town__c'] = updatedTownValue['townInfo'];;
      this.props.saveApplicationDatas(townApplicationInputDetailsData);

      prePopulatePurchaseAddressfieldValues['Town__c'] = '';
      this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
      }
      
    }
    
    if (cookie.get('postcode') && cookie.get('postcode').trim() !== '' && cookie.get('postcode').length < 9 && /^[a-zA-Z0-9\s]*$/.test(cookie.get('postcode'))) {
      const postcodeApplicationInputDetailsData = Object.assign({}, ...this.props.saveApplicationData);
      postcodeApplicationInputDetailsData['Postal_Code__c'] = cookie.get('postcode')
      this.props.saveApplicationDatas(postcodeApplicationInputDetailsData);
      prePopulatePurchaseAddressfieldValues['Postal_Code__c'] = '';
      this.props.appvalidations(prePopulatePurchaseAddressfieldValues);
    }
    return prePopulatePurchaseAddressfieldValues;
  }

  sendAddressChangepropsInPurchaseFlow = async () => {
    const cookie = new Cookies();
    let currentAddressFieldsresults = {
      'FlatNumber__c': null,
      'HouseName__c': null,
      'HouseNumber__c': null
    };

    currentAddressFieldsresults = await this.vanityCurrentAddressPrePopulate(currentAddressFieldsresults);

    const fieldsToUpdate = {
      'Address_Line1__c': 'numberAndStreet',
      'Address_Line2__c': 'addressLine2',
      'Town__c': 'townOrCity',
      'Postal_Code__c': 'postcode'
    };

    Object.keys(fieldsToUpdate).forEach(field => {
      const cookieValue = cookie.get(fieldsToUpdate[field]);
      currentAddressFieldsresults[field] = cookieValue && cookieValue !== '' ? cookieValue : '';
    });


    this.props.addressChange(currentAddressFieldsresults);
  }

  vanityCurrentAddressPrePopulate = async(currentAddressFieldsresults)=>{
    const cookie = new Cookies();
    if (cookie.get('flatAbode')) {
      currentAddressFieldsresults['Current_Flat_No__c'] = cookie.get('flatAbode');
    } else {
      currentAddressFieldsresults['Current_Flat_No__c'] = '';
    }

    if (cookie.get('houseandBuildingName')) {
      currentAddressFieldsresults['Current_House_Name__c'] = cookie.get('houseandBuildingName');
    } else {
      currentAddressFieldsresults['Current_House_Name__c'] = '';
    }

    if (cookie.get('houseandBuildingNumber')) {
      currentAddressFieldsresults['HouseNumber__c'] = cookie.get('houseandBuildingNumber');
    } else {
      currentAddressFieldsresults['HouseNumber__c'] = '';
    }
    return currentAddressFieldsresults;
  }

  fieldValidation = async (autoAddressResult,vanityAddressElements) => {
    autoAddressResult = await this.handleVanityAddressElements(vanityAddressElements,autoAddressResult);
    const isCurrentAddress= this.props.field_api_name==='Current_Address_Country__c';
    const isPreviousAddress= this.props.field_api_name==='Previous_Address__C';

    let addressLineOne = removeSpecialCharacterInAddressFields(autoAddressResult,'addressLineOneInfo',autoAddressResult['addressLineOneInfo'],'autoAddressPrePopulate');
    let addressLineTwo = removeSpecialCharacterInAddressFields(autoAddressResult,'addressLineTwoInfo',autoAddressResult['addressLineTwoInfo'],'autoAddressPrePopulate');

    if(isCurrentAddress){
      const allUserDetails = Object.assign({}, ...this.props.saveApplicationData);
      let fieldValues = {}, stageThreeValues= {}
  
      if((this.props.prepopulateStatus) && allUserDetails['Current_Residential_Status__c'] ) {
        
        fieldValues['Current_Residential_Status__c'] = '';
        stageThreeValues['Current_Residential_Status__c'] = true;
      }
      this.props.appvalidations(fieldValues);
      this.props.thirdSectionValidationUpdate(stageThreeValues);
      let currentAddressFieldsresults={};
      currentAddressFieldsresults['FlatNumber__c']=null;
      currentAddressFieldsresults['HouseName__c']=null;
      currentAddressFieldsresults['Address_Line1__c']=addressLineOne['addressLineOneInfo'];
      currentAddressFieldsresults['Town__c']=autoAddressResult['townInfo'];
      currentAddressFieldsresults['County__c']=autoAddressResult['countryInfo'];
      currentAddressFieldsresults['Postal_Code__c']=autoAddressResult['postalCodeInfo'];
      currentAddressFieldsresults['Address_Line2__c']=autoAddressResult['addressLineTwoInfo']===null?'':addressLineTwo['addressLineTwoInfo'];
      currentAddressFieldsresults['Current_Flat_No__c'] = autoAddressResult['flatNumberInfo'];
      currentAddressFieldsresults['Current_House_Name__c'] = autoAddressResult['buildingNameInfo'];
      currentAddressFieldsresults['HouseNumber__c'] = autoAddressResult['buildingNumberInfo'];
      frontEndLogs('After setting the Vanity Address Element in address fields', false, 200, 'fieldValidation', currentAddressFieldsresults)
      analyticsClickEvent('vanity_address_element_set', currentAddressFieldsresults);
      this.props.addressChange(currentAddressFieldsresults);
      let stages={}
      let inputValues={}
      Object.keys(currentAddressFieldsresults).forEach((key)=>{
      if(currentAddressFieldsresults[key] || currentAddressFieldsresults[key] === ''){
        stages[key]='';
        stages['stage'] = this.props.stage; 
        this.props.appvalidations(stages);
        inputValues[key] = currentAddressFieldsresults[key];
        this.props.saveApplicationDatas(inputValues)
        stages={};
        inputValues={};
  
        setTimeout(() => {
          const allInputDetails = Object.assign({}, ...this.props.applicationValidation);
          this.sectionValidation(key, allInputDetails);
        }, 300);
      }
      });
      
      // Check validation for all mandatory fields together after processing all fields
      setTimeout(async () => {
        const allInputDetails = Object.assign({}, ...this.props.applicationValidation);
        this.validateAllMandatoryCurrentAddressFields(allInputDetails);
      }, 300);
    }
    if(isPreviousAddress){
      let previousAddressFieldsresults={};
      previousAddressFieldsresults['Previous_Address_Line1__c']=autoAddressResult['addressLineOneInfo'];
      previousAddressFieldsresults['Previous_Town__c']=autoAddressResult['townInfo'];
      previousAddressFieldsresults['Previous_County__c']=autoAddressResult['countryInfo'];
      previousAddressFieldsresults['Previous_Postal_Code__c']=autoAddressResult['postalCodeInfo'];
      previousAddressFieldsresults['Previous_Address_Line2__c'] = autoAddressResult['addressLineTwoInfo'] === null ? '' : addressLineTwo['addressLineTwoInfo'];
      previousAddressFieldsresults['Previous_Flat_No__c'] = autoAddressResult['flatNumberInfo'];
      previousAddressFieldsresults['Previous_House_Name__c'] = autoAddressResult['buildingNameInfo'];
      previousAddressFieldsresults['Previous_HouseNumber__c'] = autoAddressResult['buildingNumberInfo'];
      this.props.addressChange(previousAddressFieldsresults);

      Object.keys(previousAddressFieldsresults).forEach((key)=>{
        const stages={stage:this.props.stage,[key]:''}
        const values={[key]:previousAddressFieldsresults[key]};
        this.props.saveApplicationDatas(values);
        this.props.appvalidations(stages);

        setTimeout(() => {
          const allInputDetails = Object.assign({}, ...this.props.applicationValidation);
           this.sectionValidation(key, allInputDetails);
        },300);
      });

        setTimeout(async () => {
          const allInputDetails = Object.assign({}, ...this.props.applicationValidation);
          this.validateAllMandatoryPreviousAddressFields(allInputDetails);
        }, 300);
    }
  }


async handleVanityAddressElements(vanityAddressElements, autoAddressResult) {
  if (vanityAddressElements && vanityAddressElements.length > 0) {
    let priorityMap = {
      "PostTown": 1,
      "City": 2,
      "Town": 3,
      "Village": 4,
      "Locality": 5
    };

    let highestPriority = 6; // Higher than any valid priority
    let selectedTownInfo = null;
    autoAddressResult['flatNumberInfo'] = '';
    autoAddressResult['buildingNameInfo'] = '';
    autoAddressResult['buildingNumberInfo'] = '';
    vanityAddressElements.map((vanityAddress) => {
      if (vanityAddress?.type?.text === "AddressPointName") {
        let flatNumberRemovedSpecialCharacter = removeSpecialCharacterInAddressFields(autoAddressResult,'flatNumberInfo',vanityAddress?.value,'autoAddressPrePopulate');
        
        autoAddressResult['flatNumberInfo'] = flatNumberRemovedSpecialCharacter['flatNumberInfo'];
      }

      if (vanityAddress?.type?.text === "BuildingName") {
        let buildingNameRemoveSpecialCharacter = removeSpecialCharacterInAddressFields(autoAddressResult,'buildingNameInfo',vanityAddress?.value,'autoAddressPrePopulate');
        autoAddressResult['buildingNameInfo'] = buildingNameRemoveSpecialCharacter['buildingNameInfo'];
      }

      if (vanityAddress?.type?.text === "BuildingNumber") {
        let buildingNoRemoveSpecialCharacter = removeSpecialCharacterInAddressFields(autoAddressResult,'buildingNumberInfo',vanityAddress?.value,'autoAddressPrePopulate');
        autoAddressResult['buildingNumberInfo'] = buildingNoRemoveSpecialCharacter['buildingNumberInfo'];
      }

      if (vanityAddress?.type?.text === "Thoroughfare") {
        let addressLineOneRemoveSpecialCharacter = removeSpecialCharacterInAddressFields(autoAddressResult,'addressLineOneInfo',vanityAddress?.value,'autoAddressPrePopulate');
        autoAddressResult['addressLineOneInfo'] = addressLineOneRemoveSpecialCharacter['addressLineOneInfo'];
      }

      if (priorityMap[vanityAddress?.type?.text] && priorityMap[vanityAddress.type.text] < highestPriority) {
        highestPriority = priorityMap[vanityAddress.type.text];
        selectedTownInfo = vanityAddress?.value;
      }

    })
    if (selectedTownInfo) {
      let townInfoRemoveSpecialCharacter = removeSpecialCharacterInAddressFields(autoAddressResult,'townInfo',selectedTownInfo,'autoAddressPrePopulate');
      autoAddressResult['townInfo'] = townInfoRemoveSpecialCharacter['townInfo'];
    }
  }

  return autoAddressResult;
}

 validateAllMandatoryCurrentAddressFields = async (allInputDetails) => {
   const mandatoryCurrentAddressFields = ['Address_Line1__c', 'Town__c', 'Postal_Code__c'];
   let stagesValues = {};
   
   // Check if all mandatory fields are filled
   const allMandatoryFieldsFilled = mandatoryCurrentAddressFields.every(field =>
     allInputDetails[field] && allInputDetails[field] !== ''
   );
   
   mandatoryCurrentAddressFields.forEach(field => {
     if(allInputDetails[field] === '' || !allInputDetails[field]) {
       stagesValues[field] = true;
     } else {
       // Only allow progression if ALL mandatory fields are filled
       stagesValues[field] = !allMandatoryFieldsFilled;
     }
   });
   
   this.props.thirdSectionValidationUpdate(stagesValues);
 }

 validateAllMandatoryPreviousAddressFields = async (allInputDetails) => {
  const mandatoryPreviousAddressFields = ['Previous_Address_Line1__c', 'Previous_Town__c', 'Previous_Postal_Code__c'];
  let stagesValues = {};
  const allMandatoryFieldsFilled = mandatoryPreviousAddressFields.every(field =>
    allInputDetails[field] && allInputDetails[field] !== ''
  );

  mandatoryPreviousAddressFields.forEach(field => {
    if(allInputDetails[field] === '' || !allInputDetails[field]) {
      stagesValues[field] = true;
    } else {
      stagesValues[field] = !allMandatoryFieldsFilled;
    }
  });
  this.props.thirdSectionValidationUpdate(stagesValues);
 }

  onBlurEvent = (e) => {
    const name = e.target.name
    if(name == 'Current_Address_Country__c'){
      GTMFieldValidChange('Current Address');
    }
    if(name == 'Previous_Address__C'){
      GTMFieldValidChange('Previous Address')
    }
  }

  currentAddressPopulate = (autoFindResult) => {
    if(autoFindResult.data.options && autoFindResult.data.result.code===100){
      let vanityAddressElements = autoFindResult['data']['vanityAddressElements'];
      frontEndLogs('Vanity Address Element from auto find address api', false, 200, 'currentAddressPopulate', vanityAddressElements)
      analyticsClickEvent('vanity_address_element_from_auto_find_address_api', vanityAddressElements);
      let autoAddressResult ={};
      autoAddressResult['addressLineOneInfo']= autoFindResult.data.reformattedAddress[0]?autoFindResult.data.reformattedAddress[0]:null;
      autoAddressResult['addressLineTwoInfo']= autoFindResult.data.reformattedAddress[1]?autoFindResult.data.reformattedAddress[1]:null;
      autoAddressResult['addressLineThreeInfo']= autoFindResult.data.reformattedAddress[2]?autoFindResult.data.reformattedAddress[2]:null;
      autoAddressResult['townInfo']= autoFindResult.data.reformattedAddress[3]?autoFindResult.data.reformattedAddress[3]:null;
      autoAddressResult['countryInfo'] = autoFindResult.data.reformattedAddress[4]?autoFindResult.data.reformattedAddress[4]:null;
      autoAddressResult['postalCodeInfo']= autoFindResult.data.postcode?autoFindResult.data.postcode:null;
    
      this.fieldValidation(autoAddressResult,vanityAddressElements);
    }
  }

  previousAddressPopulate=(autoFindResult)=>{
    if(autoFindResult.data.options && autoFindResult.data.result.code===100){
      let vanityAddressElements=autoFindResult['data']['vanityAddressElements'];
      frontEndLogs( 'Previous Address - Vanity Address Element from auto find Previous address api', false, 200, 'previousAddressPopulate', vanityAddressElements);
      analyticsClickEvent('previous_address_vanity_address_element_from_auto_find_previous_address_api', vanityAddressElements);
      frontEndLogs('Vanity Address Element from auto find Previous address api', false, 200, 'previousAddressPopulate', vanityAddressElements);
      analyticsClickEvent('vanity_address_element_from_auto_find_previous_address_api', vanityAddressElements);
      let autoAddressResult={};
      autoAddressResult['addressLineOneInfo']= autoFindResult.data.reformattedAddress[0]?autoFindResult.data.reformattedAddress[0]:null;
      autoAddressResult['addressLineTwoInfo']= autoFindResult.data.reformattedAddress[1]?autoFindResult.data.reformattedAddress[1]:null;
      autoAddressResult['addressLineThreeInfo']= autoFindResult.data.reformattedAddress[2]?autoFindResult.data.reformattedAddress[2]:null;
      autoAddressResult['townInfo']= autoFindResult.data.reformattedAddress[3]?autoFindResult.data.reformattedAddress[3]:null;
      autoAddressResult['countryInfo'] = autoFindResult.data.reformattedAddress[4]?autoFindResult.data.reformattedAddress[4]:null;
      autoAddressResult['postalCodeInfo']= autoFindResult.data.postcode?autoFindResult.data.postcode:null;
      this.fieldValidation(autoAddressResult,vanityAddressElements,"previous");
    }
  }

  onTextChange = async(e) => {
    this.setState({changeText:true})
    const value = e.target.value;
    this.setState({text:value});
    this.setState({showValidation:'yes'});
    this.handlingValidation(value);
    const autoResult=  await getAutoAddress(value);
    
    let suggestNameList=[];
  if(autoResult.data.options){
    if(autoResult.data.totalOptions!==autoResult.data.options.length){
      if(autoResult.data.options[0]){
        if(autoResult.data.options[0].links[0].href){
          const getFindAddressData=await getFindAddressSecondCall(autoResult.data.options[0].links[0].href);
          getFindAddressData.data.options.map((lists) => {
            const datalists = [
              lists.displayName,
              lists.links[0].rel,
              lists.links[0].href
            ];
            suggestNameList.push(datalists);
          });
        }
      }
    }else{
      autoResult.data.options.map((list) => {
        const datalist = [
          list.displayName,
          list.links[0].rel,
          list.links[0].href
        ];
        suggestNameList.push(datalist);
      });
    }
  }
    this.setState({suggestions:suggestNameList});

  }

  formatAddress = (address) => {
    return address.replaceAll(", ", "\n");
  };

  handlingValidation=(value)=>{
    let stages={};
      stages[this.props.field_api_name] = ''; 
      stages['stage'] = this.props.stage; 
      this.props.appvalidations(stages);
  }
 
  async hasAnotherCall(NexResult){
    let finalResult =[];
    NexResult.data.options.map((item) => {
          const lists = [
            item.displayName,
            item.links[0].rel,
            item.links[0].href
          ];
          finalResult.push(lists);
        });
        return finalResult[0];
  }
  
    async suggestionSelected(value){
      let selectAddress=value[0];
      if(value){
        if(value[0] ){
          if(value[0].includes('addresses')){
            let suggestNameList=[];
            const getFindAddressDatas=await getFindAddressSecondCall(value[2]);
            getFindAddressDatas.data.options.map((listAddress) => {
              const datalists = [
                listAddress.displayName,
                listAddress.links[0].rel,
                listAddress.links[0].href
              ];
              suggestNameList.push(datalists);
            });
            this.setState({
              suggestions: suggestNameList,
              removepopulateValue: true,
              fieldValidation: false,
            });
            this.renderSuggestions();
            return false;
          }
        }
      }
     
        let autoFindResult=  await getFindAddress(value);
        //find reformat address details stats code is 500
        if(autoFindResult?.data?.result?.code=== 500){
          let nextLink = await this.hasAnotherCall(autoFindResult);
          autoFindResult= await getFindAddress(nextLink);
          selectAddress=autoFindResult.data.input.address;
        }
          let inputValue={}
          let address = selectAddress ?? '';
          let fields=this.state.fields;
          fields[this.props.field_api_name]=address;
          this.setState(()=>({
          text:address,
          fields,
          suggestions:[]
        }))
        inputValue[this.props.field_api_name] = address.toString();
        this.props.saveApplicationDatas(inputValue)
        this.props.fieldChange(this.props.field_api_name,address);
        if(autoFindResult){
          if(this.isCurrentAddress()){
            this.currentAddressPopulate(autoFindResult);
          }
          if(this.isPreviousAddress()){
            this.previousAddressPopulate(autoFindResult);
          }
        }else{
          return '';
        }
      this.setState({
        addressTextare: address,
        editvalue: autoFindResult,
        removepopulateValue: true,
        editManuallyButton: true
          
      })      
        this.displayAddressFields('autoUpdate') 
    }
  
  displayAddressFields(updateType) {
    let display = '';
    let classNameUpdate = 'section-final-field';
    let removeClass = 'auto-section-final-field';
    if (updateType == 'autoUpdate') {
      display = 'none';
      classNameUpdate = 'auto-section-final-field';
      removeClass = 'section-final-field';
    }
    const isCurrentAddress = this.isCurrentAddress();
    const sectionFields = this.state[
      isCurrentAddress ? 'currentAddressFieldNames' : 'previousAddressFieldNames'
    ];
    sectionFields.forEach((className, index) => {
      const elements = document.getElementsByClassName(className);
      setTimeout(() => {
        window.requestAnimationFrame(() => {
          this.setElementsDisplay(elements, display, index);
        });
        const dynamicInputs = document.querySelectorAll('#third-section .dynamic-input');

        if (updateType === 'autoUpdate' && dynamicInputs.length > 0 && this.state.isChangeClicked && !this.isPreviousAddress()) {

          const finalField = Array.from(dynamicInputs).find(el =>
            el.classList.contains('duration-of-residency')
          );

          if (finalField) {
            finalField.classList.remove('section-final-field');
            finalField.classList.add('auto-section-final-field');
          }

        } else if (dynamicInputs.length > 0 && sectionFields && sectionFields.length > 0 && !this.isPreviousAddress()) {
          const finalField = Array.from(dynamicInputs).find(el =>
            el.classList.contains('duration-of-residency')
          );

          if (finalField) {
            finalField.classList.remove(removeClass);
            finalField.classList.add(classNameUpdate);
          }
        }
      }, 50);
    });
  }

  setElementsDisplay(elements, display, index) {
    Array.from(elements).forEach(el => {
      el.style.display = display;
      if (!el.classList.contains('address-fields-manual-entry')) {
        el.classList.add('address-fields-manual-entry');
      }
      el.classList.remove('is-odd', 'is-even');
      if ((index + 1) % 2 === 0) {
        el.classList.add('is-even');
      } else {
        el.classList.add('is-odd');
      }
    });
  }

    componentWillReceiveProps(nextProps) {
      if(nextProps.showCurrentAddress!='' && !nextProps.prepopulateStatus){
        console.log('nextProps.showCurrentAddress',nextProps.showCurrentAddress)
        this.props.allowManually(nextProps.showCurrentAddress)
      }
      if(nextProps.prepopulateStatus===true && this.state.changeText===false && !this.state.isChangeClicked){
        const allDetailData = Object.assign({}, ...nextProps.saveApplicationData);
        const addressValue = allDetailData[this.props.field_api_name];
        
        if(addressValue){
        this.setState({ text:addressValue,addressTextare:true,editManuallyButton:true,showFieldOptions:true,editvalue:allDetailData})}
      }
      if (nextProps.showAppValidations !== this.state.showValidation) {
        if(nextProps.showAppValidations!==''){
         this.setState({ showValidation:nextProps.showAppValidations })
        }
      } 
    }
      
 
 renderSuggestions = () => {
  const { suggestions } = this.state;
  if (suggestions.length === 0) {
    return null;
  }
  return (
    <ul className="custom-list">
      {suggestions.map((itemList) => (
        <li key={itemList}>
          <button
            type="button"
            className="field-btn"
            onClick={() => this.suggestionSelected(itemList)}
          >
            {itemList[0]}
          </button>
        </li>
      ))}
    </ul>
  )
}

onFocus = (e) => {
  e.target.setAttribute('autoComplete', 'nope')

  if(e.target.name === 'Current_Address_Country__c'){
    GTMFieldInteraction(this.props.field_label);
  }

  if(e.target.name === 'Previous_Address__C'){
    GTMFieldInteraction(this.props.field_label);
  }
}
 
  onClickEventForShowValidation = (event) => {
    if (!event) return;
    const currentAddress = this.isCurrentAddress();
    const previousAddress = this.isPreviousAddress();
    const { prepopulateStatus } = this.props;
    const shouldPrepopulateAddress = prepopulateStatus === false;
    let allData = Object.assign({}, ...this.props.saveApplicationData);
    if (currentAddress) { this.props.handleAddressChange() }
    if (currentAddress) {
      if (shouldPrepopulateAddress) {
        this.currentAddressPopulate(event);
      }
      this.props.allowManually("Current_Address_Country__c");
      const currentAddress = [allData.Current_Flat_No__c, allData.Current_House_Name__c, allData.HouseNumber__c, allData.Address_Line1__c, allData.Address_Line2__c, allData.Town__c, allData.Postal_Code__c].filter(Boolean).join(', ');
      this.props.saveApplicationDatas({ Current_Address_Country__c: currentAddress });
    }

    if (previousAddress) {
      if (!shouldPrepopulateAddress) {
        this.previousAddressPopulate(event);
      }
      this.props.allowManually("Previous_Address__C");
      const previousAddress = [allData.Previous_Flat_No__c, allData.Previous_House_Name__c, allData.Previous_HouseNumber__c, allData.Previous_Address_Line1__c, allData.Previous_Address_Line2__c, allData.Previous_Town__c, allData.Previous_Postal_Code__c].filter(Boolean).join(', ');
      this.props.saveApplicationDatas({ Previous_Address__C: previousAddress });
    }
    this.setState({
      isChangeClicked: true,
      removepopulateValue: false,
      editManuallyButton: false
    }, () => {
      this.displayAddressFields('manualUpdate');
    });
  }

  onclickEnterManually = async (event) => {
    this.setState({ isChangeClicked: true });
    if (!this.props.isChangeEmail) {
      analyticsClickEvent('enter_manually', '');
      event.preventDefault();
      this.props.allowManually(this.props.field_api_name);
      this.displayAddressFields('manualUpdate');
      this.resetFields(this.props.field_api_name);
    } else {
      const inputEmailElement = document.getElementById('Email_Address');
      inputEmailElement.focus();
    }
};

  sectionValidation = (key, allInputDetails) => {
    const currentAddressFiels=['Address_Line1__c', 'Town__c', 'Postal_Code__c'];
    const previousAddressFiels=['Previous_Address_Line1__c', 'Previous_Town__c', 'Previous_Postal_Code__c'];
    if (currentAddressFiels.includes(key)) {
      let stagesValues = {}
      if (allInputDetails[key] === '') {

        stagesValues[key] = true;
        this.props.thirdSectionValidationUpdate(stagesValues);
      }
      else {
        stagesValues[key] = false;
        this.props.thirdSectionValidationUpdate(stagesValues);
      }
    }
    if (previousAddressFiels.includes(key)) {
      let stagesValues = {}
      if (allInputDetails[key] === '') {
        stagesValues[key] = true;
        this.props.thirdSectionValidationUpdate(stagesValues);
      }
      else {
        stagesValues[key] = false;
        this.props.thirdSectionValidationUpdate(stagesValues);
      }
    }
  }

  resetFields = (fieldApi) => {
    const cookie = new Cookies();
    let mandatoryFieldList = {}, applicationFieldValues = {};
    applicationFieldValues['stage'] = 2;
    const currentFields= ['Address_Line1__c','Postal_Code__c','Town__c','Current_Flat_No__c','HouseNumber__c','Current_House_Name__c','Address_Line2__c','Current_Address_Country__c'];
    const previousFields= ['Previous_Address_Line1__c','Previous_Postal_Code__c','Previous_Town__c','Previous_Flat_No__c','Previous_House_Name__c','Previous_HouseNumber__c','Previous_Address_Line2__c'];
    let fieldsToReset=[];
	let fieldToBeCleared="";
	if(fieldApi==='Current_Address_Country__c'){
		fieldsToReset=currentFields;
		fieldToBeCleared="currentAddressFields";
	}
	else if(fieldApi==='Previous_Address__C'){
		fieldsToReset=previousFields;
		fieldToBeCleared="previousAddressFields";	
	}
    fieldsToReset.forEach((field)=>{
      mandatoryFieldList[field]=false;
      let isRequired=['Postal_Code__c','Address_Line1__c','Town__c','Previous_Postal_Code__c','Previous_Address_Line1__c','Previous_Town__c'].includes(field);
      if (cookie.get('sourceURL') || this.state.isChangeClicked || (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') || isRequired) {
      applicationFieldValues[field] = isRequired ? "This is Required" : "";
    }
    });
    this.props.thirdSectionValidationUpdate(mandatoryFieldList);
    this.props.appvalidations(applicationFieldValues);
    this.setState({
      fieldValidation: false,
    });

	if (fieldToBeCleared === "previousAddressFields") {
		this.props.saveApplicationDatas({ Previous_Address_Line1__c: '' });
		this.props.saveApplicationDatas({ Previous_Address_Line2__c: '' });
		this.props.saveApplicationDatas({ Previous_Town__c: '' });
		this.props.saveApplicationDatas({ Previous_Postal_Code__c: '' });
		this.props.saveApplicationDatas({ Previous_Flat_No__c: '' });
		this.props.saveApplicationDatas({ Previous_House_Name__c: '' });
		this.props.saveApplicationDatas({ Previous_HouseNumber__c: '' });
	}
	else if (fieldToBeCleared === "currentAddressFields") {
		this.props.saveApplicationDatas({ Address_Line1__c: '' });
		this.props.saveApplicationDatas({ Address_Line2__c: '' });
		this.props.saveApplicationDatas({ Town__c: '' });
		this.props.saveApplicationDatas({ Postal_Code__c: '' });
		this.props.saveApplicationDatas({ Current_Flat_No__c: '' });
		this.props.saveApplicationDatas({ Current_House_Name__c: '' });
		this.props.saveApplicationDatas({ HouseNumber__c: '' });
		this.props.saveApplicationDatas({ Current_Address_Country__c: '' });
	}

	let resetAddressChange={};
	fieldsToReset.forEach((field)=>{
		resetAddressChange[field]='';
	});
	this.props.addressChange(resetAddressChange);
  }

  retuneToAddressChangeField = (chooseaddress) => {
    this.setState({ isChangeClicked: true }, () => {
      if(this.isCurrentAddress())
          {this.props.handleAddressChange()
      }
      if (this.isPreviousAddress()) {
        this.props.appvalidations({
          Previous_Address__C: ''
        });

        this.props.thirdSectionValidationUpdate({
          Previous_Address__C: false
        });
      }
      if (!this.props.isChangeEmail) {
        if (chooseaddress) {
          // Preserve the value of Current_Address_Country__c
          this.setState(prevState => ({
            addressTextare: false,
            removepopulateValue: true,
            text: '',
            showFieldOptions:false,
          }));
          this.displayAddressFields('autoUpdate');
        }
        this.resetFields(this.props.field_api_name)
        this.setState(prevState => ({
          fieldValidation: true,
        }));
      } else {
        const inputEmailElement = document.getElementById('Email_Address');
        inputEmailElement.focus();
      }
    });
  }

calculateRowsForAutoAddress(text) {
  const formattedText = this.formatAddress(text);  
  const lines = formattedText.split('\n');
  return Math.max(lines.length + 1);
}

 render() {
  let disableValue=''
  if(this.props.editable===false && this.props.prepopulateStatus===true && this.props.prepopulateCondition===true){
    disableValue='nonEditable'
  }
  const allDetails = Object.assign({}, ...this.props.applicationValidation);
  
   const {text}=this.state
   return (
    <>
    <div className="dynamic-input auto-address-field">
      <div className="form-group"> 
        <div className='d-flex flex-row'>
          <span>{this.props.field_question}
          {(this.props.flxQuestionMoreInfo) &&
            <button className='fieldTip' type='button'>
              <span>
                  <img src="images/humm-infoIcon.svg" alt="humm-logo" />
                  {this.props.flxQuestionMoreInfo}
              </span>
              <img src="images/more-info-icon.svg" alt="info-icon" />
            </button>
          }
          </span>

        </div>

          <div className={`TypeAheadDropDown ${disableValue}`}>
            <input type="text" name={this.props.field_api_name} value="" readOnly={true} style={{display: "none",opacity: 0,position: "absolute"}} autoComplete="off"/>
            
            {this.state.addressTextare ? (
                <textarea className={`form-control text-area${disableValue} text-area-padding`} onChange={this.onTextChange} name={this.props.field_api_name} id="address_textarea"
                readOnly={this.props.editable}
                  placeholder={this.props.field_placeholder}  rows={this.calculateRowsForAutoAddress(this.state.text)}  value={this.formatAddress(this.state.text)} onBlur={this.onBlurEvent}
                  onFocus={this.onFocus} autoCorrect="off" autoCapitalize="none"  spellCheck="false"
                  onClick={(e) => analyticsClickEvent(this.props.field_label, '')}
                />
              ) : (
                <input className="form-control" 
                  onChange={this.onTextChange}
                  name={this.props.field_api_name}
                  placeholder='Enter postcode to search'
                  value={this.state.text} type="text" onBlur={this.onBlurEvent}  onFocus={this.onFocus} autoCorrect="off"  autoCapitalize="none" spellCheck="false" onClick={(e)=>analyticsClickEvent(this.props.field_label,'')}/>
        )}


          <div className='change-address'>
            {(this.state.showFieldOptions || this.state.addressTextare) && (
              <>
                   <button
                     type="button"
                     onClick={() => {
                       this.retuneToAddressChangeField(true);
                     }}
                     style={{ fontSize: '0.9375rem', color: '#4A4A4A', background: 'none', border: 'none', cursor: 'pointer' }}>Change</button>
                   <div className='address-edit-manually-option'>
                {this.state.editManuallyButton && (
                  <Link
                    to="#"
                    className="edit-manually"
                    onClick={(event) => {
                      if (this.state.addressTextare) {
                        const isPurchaseFlow =new Cookies().get('sourceURL') && window.location.search.includes('redirectToken');
                        if (isPurchaseFlow) {
                          this.setState({ editManuallyButton: false, addressTextare: true, showFieldOptions: true }, () => { this.displayAddressFields('manualUpdate'); if (this.isCurrentAddress()) { this.props.handleAddressChange() } });
                        } else {
                          this.onClickEventForShowValidation(this.state.editvalue);
                        }
                      }
                      event.preventDefault();
                    }}
                  >
                    Edit manually
                  </Link>
                )}
                </div>
              </>
            )}
          </div>
          {(this.state.fieldValidation && this.state.addressTextare == false) && (
            <p className="error-message">
              <span className="app-error-message" style={{ color: 'Red' }}>This is Required</span>
            </p>
          )}

          {text && 
          this.renderSuggestions()
          }
          {allDetails[this.props.field_api_name]!== '' && this.state.showValidation==='yes' && 
            <p className="error-message">
              <span className="app-error-message" style={{ color: 'Red' }}>{allDetails[this.props.field_api_name]}</span>
            </p>
          }
        </div>
      </div>
    </div>
    <div className="dynamic-input auto-address-edit-manually">
      <div className="form-group"> 
        <div className='TypeAheadDropDown address-hyperlink'>
          {(this.state.addressTextare === false) && (
                <Link to="#" className="manual-address" onClick={this.onclickEnterManually}>Enter manually instead</Link>
          )}
        </div>
      </div>
    </div>
    </>
   );
 }
 
}
export const mapStateToProps = (state) => {
  return {
      applicationValidation:state.dataStore.applicationValidation,
      showAppValidations:state.dataStore.showAppValidations,
      saveApplicationData:state.dataStore.saveApplicationData,
      prepopulateStatus:state.dataStore.prepopulateStatus,
      questionValueSave:state.dataStore.questionValueSave,
      showCurrentAddress: state.dataStore.showCurrentAddress,
      thirdSectionSteps: state.dataStore.thirdSectionSteps,
      isChangeEmail: state.dataStore.isChangeEmail,
  };
 };


export  const mapDispatchToProps = (dispatch) => {
  return {
      appvalidations:(validations)=>{
          return dispatch({
              type: 'APP_VALIDATIONS',
              value: validations
          });
      },
      saveApplicationDatas:(data)=>{
        return dispatch({
          type: 'SAVEDATA',
          value: data
      });
      },
      questionSave:(data)=>{
        return dispatch({
          type: 'QUESTIONSAVE',
          value: data
      });
      },
      thirdSectionValidationUpdate: (validations) => {
        return dispatch({
          type: "THIRD_SECTION_STEPS",
          value: validations
        });
      },
  }
 }

AutoAddress.propTypes = {
  applicationValidation: PropTypes.array,
  field_api_name: PropTypes.string,
  stage: PropTypes.string,
  showAppValidations: PropTypes.string,
  appvalidations: PropTypes.func,
  saveApplicationDatas: PropTypes.func,
  fieldChange: PropTypes.func,
  confirmationBlock: PropTypes.func,
  addressChange: PropTypes.func,
  thirdSectionValidationUpdate: PropTypes.func,
  showCurrentAddress: PropTypes.string,
  allowManually: PropTypes.func,
  prepopulateStatus: PropTypes.bool,
  field_label: PropTypes.string,
  editable: PropTypes.bool,
  prepopulateCondition: PropTypes.bool,
  isChangeEmail: PropTypes.bool,
  flxQuestionMoreInfo: PropTypes.string,
  field_placeholder: PropTypes.string,
  saveApplicationData: PropTypes.array,
  field_question: PropTypes.string,
  clearPurchaseFlowPopulateAddress: PropTypes.bool,
  handleAddressChange: PropTypes.func,
}

export default connect(mapStateToProps,mapDispatchToProps)(AutoAddress)


